import _asyncToGenerator from "/home/vsts/work/1/s/dp-components/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/home/vsts/work/1/s/dp-components/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
var __jsx = React.createElement;
import _regeneratorRuntime from "/home/vsts/work/1/s/dp-components/node_modules/@babel/runtime/regenerator/index.js";
import dynamic from "next/dynamic";
import React, { useEffect } from "react";
import { PageLayout } from "../../util/constants";
import { observer } from "mobx-react-lite";
import Head from "next/head";
import i18next from "i18next";
import { useStore } from "@dp/state";
var ReceiptPortal = dynamic(function () {
  return import("@dp/xcomp").then(function (mod) {
    return mod.ReceiptPortal;
  });
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [require.resolveWeak("@dp/xcomp")];
    }
  }
});
var ReceiptPortalPage = function ReceiptPortalPage() {
  var store = useStore();
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isStoreInitialized = _React$useState2[0],
    setIsStoreInitialized = _React$useState2[1];
  useEffect(function () {
    var _store$user;
    var isMounted = true;
    var initStore = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return store === null || store === void 0 ? void 0 : store.initComponent("ReceiptPortal");
            case 3:
              if (isMounted) {
                setIsStoreInitialized(true);
              }
              _context.next = 10;
              break;
            case 6:
              _context.prev = 6;
              _context.t0 = _context["catch"](0);
              console.error("Failed to render ReceiptPortal", _context.t0);
              if (isMounted) {
                setIsStoreInitialized(true);
              }
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 6]]);
      }));
      return function initStore() {
        return _ref.apply(this, arguments);
      };
    }();
    initStore();
    store === null || store === void 0 || (_store$user = store.user) === null || _store$user === void 0 || (_store$user = _store$user.analyticsModel) === null || _store$user === void 0 || _store$user.dispatchPageViewEvent();
    return function () {
      isMounted = false;
    };
  }, []);
  if (!isStoreInitialized) {
    return null;
  }
  return __jsx(React.Fragment, null, __jsx(Head, null, __jsx("title", null, i18next.t("title.receiptPortal.headTitle", {
    defaultValue: "Receipt Portal"
  }))), __jsx(ReceiptPortal, null));
};
ReceiptPortalPage.layout = PageLayout.DP_LAYOUT;
ReceiptPortalPage.layoutProps = {
  analyticsData: {
    pageName: "receipt look up page",
    pageType: "receipt-portal",
    primaryCategory: "Receipt flow"
  }
};
export default observer(ReceiptPortalPage);